class Klaviyo {
  constructor() {
    this.baseUrl = 'https://a.klaviyo.com';
    this.listId = window.klaviyoSettings?.listId;
    this.companyId = window.klaviyoSettings?.companyId;

    if (!this.listId) return console.log('List ID is missing');
    if (!this.companyId) return console.log('Company ID is missing');

    this.requestOptions = {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        revision: '2025-10-15',
        'content-type': 'application/vnd.api+json',
      },
    };
  }

  async createClientSubscription({ customSource, email, firstName, lastName, location }) {
    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: customSource,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
                first_name: firstName,
                last_name: lastName,
                location: {
                  address1: location.address,
                  zip: location.zip,
                  city: location.city,
                  country: location.country,
                },
              },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: this.listId,
            },
          },
        },
      },
    };

    // Set the request options
    this.requestOptions.body = JSON.stringify(payload);

    // Fetch the subscription
    const response = await fetch(
      `${this.baseUrl}/client/subscriptions/?company_id=${this.companyId}`,
      this.requestOptions
    );

    // If the response is not ok or the status is not 202, throw an error
    if (!response.ok || response.status !== 202) {
      throw new Error('Failed to create client subscription');
    }
  }
}

var klaviyo = new Klaviyo();

class BrandbookForm extends HTMLElement {
  form = this.querySelector('form');
  acceptsMarketingInput = this.querySelector('#accepts-marketing');

  connectedCallback() {
    this.form.addEventListener('submit', (event) => this.handleFormSubmit(event));
  }

  async handleFormSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const formData = new FormData(this.form);
    if (!formData.get('contact[email]')) return;

    try {
      this.acceptsMarketingInput.checked && (await this.handleCreateClientSubscription(formData));

      this.form.submit();
    } catch (error) {
      console.error(error);
    }
  }

  async handleCreateClientSubscription(formData) {
    return await klaviyo.createClientSubscription({
      customSource: 'Brandbook Form',
      email: formData.get('contact[email]'),
      firstName: formData.get('contact[first_name]'),
      lastName: formData.get('contact[last_name]'),
      location: {
        address: formData.get('contact[address]'),
        zip: formData.get('contact[zip]'),
        city: formData.get('contact[city]'),
        country: formData.get('contact[country]'),
      },
    });
  }
}

customElements.define('brandbook-form', BrandbookForm);
